// API Key
export const API_URL = import.meta.env.VITE_API_URL;

export const SITEKEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
